// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"7538":"recorder","9983":"profiler"}[chunkId] || chunkId) + "." + {"5072":"da971e1864289de0","7538":"c3dd69fa088a0a45","9926":"21a46f230dc33cfe","9983":"bdf5aaa6152e3390"}[chunkId] + ".js";
};